module.exports = __webpack_public_path__ + "static/media/press_content_10.415707b9.png";